import { computed, ref } from 'vue'

export const useDocumentRowStock = (registryStore, currentDeposit, secondaryDeposit = null) => {
  const stocks = ref([])
  const stocksLoaded = ref(false)
  const currentCost = ref(null)
  const positionChange = ref(null)
  let requestId = 0

  const emptyStock = {
    stock: 0,
    ordered: 0,
    customer_committed: 0,
    workshop_committed: 0,
    average_cost: 0,
    weighted_average_cost: 0,
    last_cost: 0,
    minimum_stock: 0,
    maximum_stock: 0,
    position: '',
  }

  const loadProductStocksAsync = async(productRef, cost = null) => {
    const id = ++requestId
    stocks.value = []
    stocksLoaded.value = false
    currentCost.value = cost
    positionChange.value = null
    if (!productRef) return

    try {
      const { data } = await registryStore.api.getProductStocksAsync({ product_ref: productRef, $notop: true })
      if (id === requestId) {
        stocks.value = data
        stocksLoaded.value = true
      }
    } catch {
      return
    }
  }

  const setStockPosition = (position) => { positionChange.value = { id: stockInfo.value.id, position } }

  const stockInfo = computed(() => {
    const stock = stocks.value.find(item => item.deposit === currentDeposit.value) || (stocksLoaded.value ? emptyStock : null)
    const secondary = stocks.value.find(item => item.deposit === secondaryDeposit?.value) || (stocksLoaded.value && secondaryDeposit?.value ? emptyStock : null)

    const secondaryQuantities = secondary ? {
      stock_secondary: secondary.stock,
      ordered_secondary: secondary.ordered,
      customerCommitted_secondary: secondary.customer_committed,
      workshopCommitted_secondary: secondary.workshop_committed,
      theoreticalStock_secondary: secondary.stock + secondary.ordered - secondary.customer_committed - secondary.workshop_committed,
    } : {}

    if (!stock) return { ...secondaryQuantities, currentCost: currentCost.value }

    return {
      ...stock,
      ...secondaryQuantities,
      position: positionChange.value && positionChange.value.id === stock.id ? positionChange.value.position : stock.position,
      customerCommitted: stock.customer_committed,
      workshopCommitted: stock.workshop_committed,
      theoreticalStock: stock.stock + stock.ordered - stock.customer_committed - stock.workshop_committed,
      averageCost: stock.average_cost,
      weightedAverageCost: stock.weighted_average_cost,
      lastCost: stock.last_cost,
      currentCost: currentCost.value ?? 0,
    }
  })

  const otherDeposits = computed(() => {
    const deposits = registryStore.getLocalizedDeposits()
    return stocks.value.filter(stock => stock.deposit !== currentDeposit.value).map(stock => {
      const deposit = deposits.find(item => item.id === stock.deposit)
      return {
        id: stock.deposit,
        code: deposit?.code ?? String(stock.deposit),
        name: deposit?.name ?? '',
        stock: stock.stock,
      }
    })
  })

  return { loadProductStocksAsync, stockInfo, otherDeposits, setStockPosition, positionChange }
}
